export enum ProviderType { 
    SIMPLEX = 'simplex', 
    KRIPTONMARKET = 'kriptonmarket',
    ONRAMPER = 'onramper',
    COINCAEX = 'coincaex' 
};